<template>
    <modal-wrapper modalClass="modal" :modalName="name" @before-open="beforeOpen">
        <div class="modal__header">
            <h1>{{$t('modals.start_client_trajectory.title')}}</h1>
        </div>
        <div class="modal__content">
            <div v-if="uploadErrors.length" class="alert--error" >
                <span v-for="err in uploadErrors" :key="err"> {{ err }} </span>
            </div>
            <h2>{{$t('modals.start_client_trajectory.choose_plan')}}</h2>
            <input v-if="!planUploadLoading" type="file" accept=".pdf, .doc, .docx, .png, .jpg, .jpeg, .bmp, .gif" name="planUpload" id="planUpload" ref="planUpload" style="display:none" @change="onClientPlanSelected">
            <loading-button @submited="$refs.planUpload.click()" :loading="planUploadLoading" :text="$t('common.choose_file')" @complete="!uploadErrors.length && $modal.hide(name)"></loading-button>
            <span> {{plan ? plan.name : ''}} </span>
        </div>
        <div class="modal__footer">
            <div class="actions">
                <button class="actions__action--save pull-right" :class="{disabled: !plan || planUploadLoading}" :disabled="!plan || planUploadLoading" @click="uploadClientPlan()">{{$t('modals.start_client_trajectory.upload_and_start')}}</button>
                <button class="actions__action--cancel" type="button" @click="$modal.hide(name)">{{$t('modals.common.cancel')}}</button>
            </div>
        </div>
    </modal-wrapper>
</template>
<script>
    import Vue from 'vue';
    import { Component, Prop } from 'vue-property-decorator';
    import { getFormatedDate } from '@/helpers';
    import ModalWrapper from '@/components/general/ModalWrapper';
    import LoadingButton from '@/components/general/LoadingButton';

    import { GET_TRAJECTORY } from '@/store/modules/trajectory';
    import { GET_DOCUMENTS } from '@/store/modules/documents';

    @Component({
        components: {
            LoadingButton,
        }
    })
    export default class TrajectoryStartClientModal extends Vue {
        name = 'trajectory-start-client-modal';
        planUploadLoading = false;
        uploadErrors = [];
        plan = null;

        beforeOpen() {
            this.planUploadLoading = false;
            this.uploadErrors = [];
            this.plan = null;
        }

        onClientPlanSelected(e) {
            var files = e.target.files || e.dataTransfer.files;
            if (!files.length) return;
            this.plan = files[0];
        }

        uploadClientPlan() {
            if (!this.plan) return;

            var formData = new FormData();
            formData.append('trajectory_plan', this.plan, this.plan.name);

            this.planUploadLoading = true;
            this.uploadErrors = [];
            this.axios.post(`trajectories/${this.$store.state.trajectory.trajectory.id}/start-client`, formData).then(res => {
                this.$notify.success(this.$t('notify.start_client_trajectory.uploaded_and_sent'));
                this.$store.dispatch(GET_TRAJECTORY, {});
            }).catch(err => {
                if (err.status === 422 && err.errors) {
                    this.uploadErrors = err.errors;
                    this.$notify.error(this.$t('common.validation_error'));
                } else {
                    this.$notify.error(this.$t('notify.start_client_trajectory.error'));
                }
            }).then(() => {
                this.planUploadLoading = false;
            });
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/modals/dashboard/TrajectoryStartClientModal.vue